import { render } from "./ChannelModalImport.vue?vue&type=template&id=b6172952"
import script from "./ChannelModalImport.vue?vue&type=script&lang=js"
export * from "./ChannelModalImport.vue?vue&type=script&lang=js"

import "./ChannelModalImport.vue?vue&type=style&index=0&id=b6172952&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__